import { ServiceProvider } from '@quasarcast/vue-service'
import { useFetchResources } from '@vuemodel/orion-pinia-orm'
import Role from 'modules/Role/Role'
import makeSqliteStorer from 'services/storage/local/makeSqliteStorer'
import stringSerializer from 'src/shared/serializers/stringSerializer'
import { readFuelloxAuthToken } from 'src/auth/readFuelloxAuthToken'

export const permissionsServiceProvider: ServiceProvider = {
  /**
   * Boot is run after all services are registered
   */
  setup () {
    const rolesFetcher = useFetchResources(Role, {
      storagePersist: true,
      preferStorage: true,
      include: ['permissions'],
    })

    const tokenStorer = makeSqliteStorer('fuellox', 'fuelloxToken', undefined, stringSerializer)
    readFuelloxAuthToken(() => tokenStorer.get()).then(token => {
      if (token) {
        rolesFetcher.fetch()
      }
    })
  },
}
